<template>
  <v-dialog
    v-model="active"
    width="30%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Evaluacion de investigación socioeconómica
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container v-if="evaluacionIse">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Evaluado"
                :value="getFullName(evaluacionIse.Derivacion.Programacion.Expediente.Personal)"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="evaluacionIse.fk_idCatEstatusEvaluacion"
                label="Estatus de evaluación"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                :items="estatusEvaluacion"
                item-color="secondary"
                item-text="title"
                item-value="id"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="secondary"
          :disabled="loading"
          :loading="loading"
          @click="triggerUpdateIse()"
        >
          Guardar cambios
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionIse: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacion: 'getEstatusEvaluacion',
    }),
  },

  methods: {
    ...mapActions('evaluacionesISE', ['updateEstatusEvaluacionIse']),

    closeDialog() {
      this.$emit('close');
      this.loading = false;
    },

    async triggerUpdateIse() {
      this.loading = true;
      await this.updateEstatusEvaluacionIse(this.evaluacionIse);
      this.closeDialog();
    },
  },
};
</script>
